import React from "react";

type PoleData = {
	schoolName: string;
	pole_Number: string;
	type: string;
	material: string;
	high?: number;
	medium?: number;
	low?: number;
};

interface GeneralInfoProps {
	data: PoleData;
	getFlooredFixed: (num: number | string | null | undefined) => string;
	showPolePriority: (pole: PoleData) => string;
}

const GeneralInfo: React.FC<GeneralInfoProps> = ({
	data,
	getFlooredFixed,
	showPolePriority,
}) => {
	return (
		<fieldset className="border rounded" id="fildset">
			<legend className="legend-text float-none w-auto">GENERAL</legend>
			<div className="form mx-2 mb-1" id="form">
				<div className="form-controls mb-2" id="form-controls">
					<div className="label" id="school">School</div>
					<div className="form-value" id="school">{data.schoolName}</div>
				</div>
				<div className="form-controls mb-2" id="form-controls">
					<div className="label" id="polenumber">Pole Number</div>
					<div className="form-value" id="polenumber">{data.pole_Number}</div>
				</div>
				<div className="form-controls mb-2" id="form-controls">
					<div className="label" id="type">Pole Type</div>
					<div className="form-value" id="type">{data.type}</div>
				</div>
				<div className="form-controls mb-2" id="form-controls">
					<div className="label" id="material">Pole Material</div>
					<div className="form-value" id="material">{data.material}</div>
				</div>
				<div className="form-controls mb-2" id="form-controls">
					<div className="label" id="material">Priority</div>
					<div className="form-value" data-testid="material">{showPolePriority(data)}</div>
				</div>
				<div className="form-controls mb-2" id="form-controls">
					<div className="label" id="type">Latitude</div>
					<div className="form-value" id="type">{getFlooredFixed(sessionStorage.getItem("latitude"))}</div>
				</div>
				<div className="form-controls mb-2" id="form-controls">
					<div className="label" id="type">Longitude</div>
					<div className="form-value" id="type">{getFlooredFixed(sessionStorage.getItem("longitude"))}</div>
				</div>
			</div>
		</fieldset>
	);
};

export default GeneralInfo;

